import { render, staticRenderFns } from "./BPMNEdge.vue?vue&type=template&id=07544726"
import script from "./BPMNEdge.vue?vue&type=script&lang=js"
export * from "./BPMNEdge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports